import styled from 'styled-components';
import PrimaryButton from '@carvana/showroom-forms/Button/Primary';
import { getMediaQuery } from '@carvana/showroom-theme';
import GreenCheckOutlinedIcon from '../../../images/icons/green-check-outlined.svg';

export const HeaderThree = styled.h3`
  padding-bottom: 1.625rem;
  font-size: 1rem;
  color: ${(props) => props.theme.color.primary.v600};
`;

export const ArticleHelpfulWrapper = styled.div`
  margin-top: 3rem;
`;

export const ArticleHelpfulButtons = styled.div`
  max-width: 22rem;
  display: flex;
  justify-content: space-between;
`;

export const ThanksForFeedback = styled.div`
  text-transform: uppercase;
  font-size: 14px;
  line-height: 20px;
  font-weight: 700;
  display: flex;
  align-items: center;
`;

export const FeedbackWrapper = styled.div`
  max-width: 676px;
`;

export const FeedbackTextArea = styled.textarea`
  margin-top: 1rem;
  padding: 1rem;
  width: 100%;
  height: 7rem;
  border: 1px solid ${(props) => props.theme.color.neutral.v300};
  box-sizing: border-box;
  border-radius: 4px;
  color: ${(props) => props.theme.color.neutral.v500};

  /* focus-border */
  overflow: auto;
  outline: none;
  box-shadow: none;
  resize: none;
`;

export const FeedbackSubmitButton = styled(PrimaryButton)`
  width: 100%;

  ${(props) => getMediaQuery(props.theme.breakpoint.md)} {
    max-width: 20rem;
  }
`;

export const GreenCheckOutlined = styled(GreenCheckOutlinedIcon)`
  width: 1.5rem;
  height: 1.5rem;
  margin-right: 0.25rem;
`;

export const FeedbackContactUsWrapper = styled.div``;

export const ContactFlowWrapper = styled.div`
  padding: 5rem 0 3rem;
  max-width: 694px;
  margin: 0 auto;

  ${(props) => getMediaQuery(props.theme.breakpoint.sm)} {
    padding: 4rem 0;
  }
`;

export const FeedbackSubmitWrapper = styled.div`
  padding-top: 1rem;
`;
